import type { ModelUsageSummary } from "@/types";
import { escapeHtml, fmtNum } from "@/utils";

const colors = ["#2563eb", "#7c3aed", "#db2777", "#ea580c", "#16a34a", "#0891b2", "#ca8a04", "#4f46e5"];

function emptySummary(): ModelUsageSummary {
  return { requests: 0, totalTokens: 0, models: [] };
}

function renderPie(summary: ModelUsageSummary, metric: "requests" | "totalTokens", label: string): string {
  const entries = (summary.models || []).filter((item) => Number(item[metric] || 0) > 0);
  const total = entries.reduce((sum, item) => sum + Number(item[metric] || 0), 0);
  if (!total) {
    return `<article class="model-usage-pie-card"><h4>${label}</h4><p class="muted">暂无成功调用数据</p></article>`;
  }
  let offset = 0;
  const segments = entries.map((item, index) => {
    const percent = Number(item[metric] || 0) * 100 / total;
    const start = offset;
    offset += percent;
    return `${colors[index % colors.length]} ${start.toFixed(3)}% ${offset.toFixed(3)}%`;
  });
  const metricLabel = metric === "requests" ? "次调用" : "Tokens";
  return `
    <article class="model-usage-pie-card">
      <h4>${label}</h4>
      <div class="model-usage-pie-layout">
        <div class="model-usage-pie" style="background:conic-gradient(${segments.join(",")})">
          <div><strong>${fmtNum(total)}</strong><span>${metricLabel}</span></div>
        </div>
        <ul class="model-usage-legend">
          ${entries.map((item, index) => {
            const value = Number(item[metric] || 0);
            const percent = value * 100 / total;
            return `<li><i style="background:${colors[index % colors.length]}"></i><span title="${escapeHtml(item.model)}">${escapeHtml(item.model)}</span><strong>${percent.toFixed(1)}%</strong><small>${fmtNum(item.requests)} 次 · ${fmtNum(item.totalTokens)} Token</small></li>`;
          }).join("")}
        </ul>
      </div>
    </article>
  `;
}

export function renderModelUsageCharts(summary: ModelUsageSummary | undefined | null): string {
  const value = summary || emptySummary();
  return `<div class="model-usage-chart-grid">${renderPie(value, "requests", "按调用次数")}${renderPie(value, "totalTokens", "按 Token")}</div>`;
}
